module.exports = __webpack_public_path__ + "img/sitting-by-tree-mask.e34789cf.png";